import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';

/**
 * Shown when search returns zero listings.
 * When a category (pub_categoryLevel1) is locked, a CTA is offered to switch
 * to the other category instead of showing zero results from both.
 *
 * @param {Object} props
 * @param {boolean} props.listingsAreLoaded
 * @param {number} props.totalItems
 * @param {Object} props.location
 * @param {Function} props.resetAll
 * @param {boolean} props.showCreateListingsLink
 * @param {string|null} [props.lockedCategory] - 'workspaces' | 'services' | null
 * @param {Function} [props.onSwitchCategory] - called with the other category value
 */
const NoSearchResultsMaybe = props => {
  const {
    listingsAreLoaded,
    totalItems,
    location,
    resetAll,
    showCreateListingsLink,
    lockedCategory,
    onSwitchCategory,
  } = props;

  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink className={css.createListingLink} name="NewListingPage">
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : null;

  // When on a category-locked page offer a switch CTA instead of reset
  const switchCategory = lockedCategory === 'workspaces' ? 'services' : 'workspaces';
  const switchLabelId =
    lockedCategory === 'workspaces'
      ? 'NoSearchResultsMaybe.switchToServices'
      : lockedCategory === 'services'
      ? 'NoSearchResultsMaybe.switchToSpaces'
      : null;

  const switchCTAMaybe =
    lockedCategory && switchLabelId && onSwitchCategory ? (
      <div className={css.switchCategoryWrap}>
        <button
          type="button"
          className={css.switchCategoryButton}
          onClick={() => onSwitchCategory(switchCategory)}
        >
          <FormattedMessage id={switchLabelId} />
        </button>
      </div>
    ) : null;

  const resetButtonMaybe =
    !lockedCategory && hasSearchParams ? (
      <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
        <FormattedMessage id="SearchPage.resetAllFilters" />
      </button>
    ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <p className={css.noResultsHeading}>
        <FormattedMessage id="SearchPage.noResults" />
      </p>
      {switchCTAMaybe}
      {resetButtonMaybe ? (
        <div className={css.secondaryActions}>{resetButtonMaybe}</div>
      ) : null}
      {/* <p>{createListingLinkMaybe}</p> */}
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
